export const PROFILE_PHOTO_SIZE = 104
export const MAX_CONTENT_WIDTH = 1280

/**
 * Horizontal gutter for the centered, max-width content containers. Keeps the
 * content off the viewport edges when the window is narrower than
 * MAX_CONTENT_WIDTH. Applied as left/right padding on each `max-width +
 * margin: 0 auto` container (box-sizing: border-box, so the container still
 * caps at MAX_CONTENT_WIDTH).
 */
export const CONTENT_GUTTER = 24
